import React from 'react';
import ReactDOM from 'react-dom';
import Timetable from './Timetable';
import { ThemeProvider } from 'styled-components';
import _ from 'lodash';
import {
  doUseDevModeInstedOfWaitingForOptions,
  parseOptionsFromIframePostMessage,
  showTimetableTakingAWhileToLoadOnTimeout,
} from '../shared/utils/startUtils';
import { ConfigContext } from './ConfigContext';

export function startSessionsTimetable() {
  let theme = {
    primary: '#ef9819',
  };

  /** @type {import('../shared/utils/startUtils').LoadTimetable} */
  const loadTimetable = (options, id, didUpdate) => {
    theme = { ...theme, ...options.customStyle };

    ReactDOM.render(
      <ThemeProvider theme={theme}>
        <ConfigContext.Provider value={options}>
          <Timetable didUpdate={didUpdate} {...options} />
        </ConfigContext.Provider>
      </ThemeProvider>,
      document.getElementById(id)
    );
  };

  const useDevModeInsteadOfWaitingForOptions = doUseDevModeInstedOfWaitingForOptions(
    process.env.NODE_ENV,
    window.location.href
  );
  if (useDevModeInsteadOfWaitingForOptions) {
    loadTimetableInDevMode(loadTimetable);
  } else {
    loadTimetableInEmbeddedMode(loadTimetable);
  }
}

/**
 * @param {import('../shared/utils/startUtils').LoadTimetable} loadTimetable
 */
function loadTimetableInDevMode(loadTimetable) {
  import('./dev/options').then((module) => loadTimetable(module.default, 'root'));
}

/**
 * @param {import('../shared/utils/startUtils').LoadTimetable} loadTimetable
 */
function loadTimetableInEmbeddedMode(loadTimetable) {
  window.loadTimeTable = loadTimetable;

  const loadingMessage = document.createElement('div');
  loadingMessage.className = 'loading';
  loadingMessage.innerText = 'Loading...';
  const rootNode = document.getElementById('root');
  rootNode.appendChild(loadingMessage);

  const loadTimeout = showTimetableTakingAWhileToLoadOnTimeout();

  window.addEventListener('message', (e) => {
    const parseResult = parseOptionsFromIframePostMessage(e);
    if (!parseResult.isOptions) {
      return;
    }
    const { options } = parseResult;

    /* existence of the `apiKey` field indicates that this is probably an imin timetable load message rather than a message from some other source
    
    TODO have a more thorough check e.g. by setting the `type` of the message object to `IminLoadTimetable` 
    
    We used the apiKey to ensure backwards compatibility rather than introduce a new field which all of our cusomters would need to implement. */
    if (!_.isNil(options.apiKey)) {
      if (loadTimeout) {
        window.clearTimeout(loadTimeout);
      }

      if (typeof options === 'object') {
        if (!Array.isArray(options.bookableProviders)) {
          options.bookableProviders = [];
        }
        if (!_.isPlainObject(options.memberDeepLinks)) {
          options.memberDeepLinks = {};
        }
        if (_.isNil(options.isCategoryFilter)) {
          options.isCategoryFilter = false;
        }
        if (_.isNil(options.admissionsPolicyUrl)) {
          options.admissionsPolicyUrl = null;
        }
        if (_.isNil(options.showActivityTypes)) {
          options.showActivityTypes = true;
        }
        loadTimetable(options, 'root', () => {
          const height = document.getElementById('root').getBoundingClientRect().height + 7;
          if (height > 140) {
            window.parent.postMessage(height, e.origin);
          }
        });
      }
    } else {
      console.error('No apiKey provided in the options object');
    }
  });
}
